"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    // Because of multiple IDs on page
    (0, _jquery2.default)(".cart-detail .user-login-form .icon--user").click(function (e) {
        e.preventDefault();
        (0, _jquery2.default)(this).prev("input").focus();
    });
    (0, _jquery2.default)(".cart-detail .user-login-form .icon--key").click(function (e) {
        e.preventDefault();
        (0, _jquery2.default)(this).prev("input").focus();
    });
};

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/modalLoginInCartHack.js
// module id = 1073
// module chunks = 0